<template>
        <div>
            <slot />
        </div>
</template>

<script>
    export default {
        name: "NoSidebar"
    }
</script>

<style scoped>

</style>